import { render, staticRenderFns } from "./DialogCreatePosition.vue?vue&type=template&id=6b9aca2a&scoped=true&"
import script from "./DialogCreatePosition.vue?vue&type=script&lang=js&"
export * from "./DialogCreatePosition.vue?vue&type=script&lang=js&"
import style0 from "./DialogCreatePosition.vue?vue&type=style&index=0&id=6b9aca2a&lang=scss&scoped=true&"
import style1 from "./DialogCreatePosition.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9aca2a",
  null
  
)

export default component.exports